
const baseURL = useRuntimeConfig().public.baseURL;

export const getPublicProgramDetails = async (program_uuid) => {
  try {
    let url = `${baseURL}/api/individuals/program-details/`+ program_uuid

    return fetch(url)
    .then(response => response.json())
  } catch (error) {
    console.error('Error fetching Program Data:', error)
    throw error
  }
}

export function registerUserProgram(program_uuid) {
  try {
    let url = `${baseURL}/api/individuals/user-program-register/` + program_uuid + '/';

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => response.json());
  } catch (error) {
    console.error('Error fetching Program Data:', error);
    throw error;
  }
}


export function registerUserCourse(course_id) {
  try {
    let url = `${baseURL}/api/individuals/enroll-course/?course_id=` + course_id;
    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
    })
    .then(response => response.json());
  } catch (error) {
    console.error('Error fetching Course Data:', error);
    throw error;
  }
}